import React from 'react';


/* Usage
# Instead of component
return condition
    ? (
        <RegularComponent />
    )
    : <InComponentLoader show={true} message={"message to show while loader is shown"} />
# Aside a component
<DOM>
    <InComponentLoader show={!!!condition} message={"message to show while loader is shown"} />
    <RegularComponent hidden={!contidion} />
</DOM>
*/
const InComponentLoader = props => {
    // Receive {show, message}
    return props.show
        ? (
            <div>
                <br/><br/>
                <span id="boletinHTMLPreview">
                    <center style={{paddingBottom: "300px"}}>
                        <h5>{props.message}</h5>
                    </center>
                </span>
                <div className="loader" style={{marginLeft: "-55px"}}></div>
            </div>
        )
        : "";
}

export default InComponentLoader;
